import Vue from 'vue';
import { required, url, maxLength, decimal, between } from 'vuelidate/lib/validators'
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';

export default Vue.component('ed-lesson-create-link', {
  name: 'ed-lesson-create-link',
  props: ['params'],
  mixins: [CreateObjectsMixin],
  components: {
    EdSelectTag: () => import(/* EdSelectTag */'@/courses/components/ed-select-tag/ed-select-tag.component.vue')
  },
  data: () => {
    return {
      form: {},
      section: null,
      title:'',
      saving: false,
      tags: ['TEST', 'CLASSWORK', 'HOMEWORK'],
      tagSelected: '',
    }
  },
  computed: {
    creating() {
      return 'section' in this.params || this.section == null;
    }
  },
  methods: {
    init(name = '', urlVal = '') {
      this.form = EdFormModel([
        EdInputModel('name', name, { required, maxLength: maxLength(60) }),
        EdInputModel('url', urlVal, { required, url } ),
        EdInputModel('grade', '', { decimal, between: between(0, 100)})
      ]);
      if(!this.hasGradeField) {
        this.form.setValid('grade', true);
      }
    },
    closeModal() {
      this.$EdModal.closeModal();
    },
    async saveUrl() {
      this.saving = true;
      let data: any = {
        type : this.params.type,
        name : this.form.name.value,
        text : this.form.url.value,
        parentId: this.params.parentId,
        courseId: this.params.courseId,
        classId: this.params.classId,
        labelSections: this.tagSelected,
        component: this.componentSelected
      }
      if(this.isFeedBack) {
        if(this.hasGradeField) data.grade = this.form.grade.value;
          this.$edEventBus.$emit(this.params.modalBusSaveEvent, data, this.params);
          await this.refreshSelectedStudentWidget();
      } else {
        if(this.creating) {        
          await this.createObject(data);
        } else {  
          data = Object.assign({}, this.section);
          data.name = this.form.name.value;
          data.text = this.form.url.value;
          data.labelSections = this.tagSelected;
          data.component = this.componentSelected;
          await this.editObject(data);        
        }
      }      
      this.closeModal();
    }
  },
  created() {
    if(SectionsProvider.getSectionById(this.course.sections, this.params.objId) !== null) {
      this.section = SectionsProvider.getSectionById(this.course.sections, this.params.objId).value;
    }
    this.title = this.params.titleModal || '';
    if(this.creating) {
      this.init();
      if(this.course.eduacComponents) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    }else {
      this.init(this.section.name, this.section.text, this.section.description);
      this.tagSelected = this.section.labelSections;
      if(this.section.component) {
        this.componentSelected = this.components.find(c => c.id == this.section.component.id);
      } else if(this.components) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    }
  }
});